import useUpdateShopifyPreferenceNotifications from "@babackapp/private-api-client/client/use-update-shopify-preference-notifications";
import { Card, CardContent } from "@babackapp/ui/components/card";
import {
  ShopifyNotificationsFormValues,
  ShopifyPreferencesNotificationsForm,
} from "./shopify-preferences-notifications-form";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

export default function CustomerPortalNotificationsCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { mutateAsync: updateShopifyPreferenceNotifications } =
    useUpdateShopifyPreferenceNotifications(shop);

  if (!shop) {
    return null;
  }

  const onSubmitShopifyNotifications = (
    data: ShopifyNotificationsFormValues,
  ) => {
    return updateShopifyPreferenceNotifications({
      emailFrom: data.emailForm,
      emails: data.emails,
      shopifyEmails: {
        refundEmail: data.refundEmail,
        labelEmail: data.labelEmail,
      },
    });
  };

  return (
    <Card className="w-full">
      <CardContent>
        <ShopifyPreferencesNotificationsForm
          onSubmit={onSubmitShopifyNotifications}
          defaultValues={{
            emailForm: shop.preferences.notifications.emailFrom,
            emails: shop.preferences.notifications.emails,
            refundEmail:
              shop.preferences.notifications.shopifyEmails.refundEmail,
            labelEmail: shop.preferences.notifications.shopifyEmails.labelEmail,
          }}
        />
      </CardContent>
    </Card>
  );
}
